function flip(originalPositions, getElements) {
  return function () {
    var elements = getElements();
    var n = elements.length,
      i;
    var elId, bbox;

    for (i = 0; i < n; i++) {
      elId = elements[i].getAttribute("id");

      if (!Object.prototype.hasOwnProperty.call(originalPositions, elId)) {
        continue;
      }

      bbox = elements[i].getBoundingClientRect();

      elements[i].dataset.flipping = true;
      elements[i].style.setProperty("--i", i);
      elements[i].style.setProperty("--dx", bbox.x - originalPositions[elId].x);
      elements[i].style.setProperty("--dy", bbox.y - originalPositions[elId].y);
      elements[i].style.setProperty(
        "--dw",
        bbox.width / originalPositions[elId].width
      );
      elements[i].style.setProperty(
        "--dh",
        bbox.height / originalPositions[elId].height
      );
    }

    window.requestAnimationFrame(function () {
      for (i = 0; i < n; i++) {
        delete elements[i].dataset.flipping;
      }
    });
  };
}

module.exports = {
  flip: flip,
};
